

















































































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class extends AbpBase {
    @Prop() formdata: any;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formBuilder/formConfig.vue